import script from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminPage.vue?vue&type=style&index=0&id=752374ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752374ac"]])

export default __exports__